module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "loginform"
    }
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.submitLogin
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_vm._v("\n        username:"), _c('input', {
    ref: "hph_user",
    attrs: {
      "name": "hph_user",
      "type": "text",
      "placeholder": "กรอกชื่อผู้ใช้งาน",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_vm._v("\n        password:"), _c('input', {
    ref: "hph_pass",
    attrs: {
      "name": "hph_pass",
      "type": "password",
      "placeholder": "กรอกรหัสผ่าน",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('input', {
    ref: "btn_login",
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "margin-left": "80px"
    },
    attrs: {
      "name": "btn_login",
      "type": "submit",
      "value": "Login"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "reset",
      "value": "Cancle"
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('h3', [_vm._v(" เข้าสู่ระบบ ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "resumator-textarea-medium"
  }, [_vm._v("\n              (ใช้รหัสเดียวกันกับศูนย์แจ้งเตือนภัยฯ)\n         ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('a', {
    staticClass: "bigbutton",
    attrs: {
      "href": "http://www.tumdee.org/alert/hph/",
      "target": "_blank"
    }
  }, [_vm._v("\n            ลงทะเบียน\n        ")]), _vm._v(" \n        "), _c('a', {
    staticClass: "bigbutton",
    attrs: {
      "href": "http://www.tumdee.org/alert/hph/",
      "target": "_blank"
    }
  }, [_vm._v("\n            ลืมรหัสผ่าน\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 form-group text-center"
  }, [_c('a', {
    attrs: {
      "href": "https://www.thaimushroom.net/mushroom.apk.zip",
      "download": ""
    }
  }, [_c('img', {
    staticStyle: {
      "height": "160px"
    },
    attrs: {
      "src": require("../assets/mushrooms.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        Download Android App"), _c('br'), _vm._v("\n        (เวอร์ชั่นทดลองใช้)\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5d2ec80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginForm.vue
// module id = 1095
// module chunks = 1